import moment from 'moment'
export default {
  props: {
    comData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    activityData() {
      return this.comData;
    },
    countDownTime() {
      if (!this.comData.endTime) {
        return 0;
      }
      return moment(this.comData.endTime).valueOf() - moment().valueOf();
    },
    joinBtnText() {
      return this.comData.isPreview == 1 
        ? '活动预览，不可参与'  
        : '请扫描海报进行参与';
    },
    // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      signUpData: {
        browsePeopleNumber: 0,
        signUpNumber: 0,
        signUpList: []
      }
    }
  },
  methods: {
    // 报名信息
    getSignUPData() {
      if (this.activityData.isPreview == 1 || !this.creationMode) {
        return;
      }
      // 非预览的时候，查询报名参与信息
      this.$api.h5.getActivityStatistic(this.activityData.activityId)
        .then(({data}) => {
          if (data) {
            this.signUpData = data;
          }
        });
    }
  },
  created() {
    this.getSignUPData();
  },
  filters: {
    joinUserName(name) {
      let sliceName = name.slice(0,1)
      return sliceName + new Array(name.length - 1).join('*')
    }
  }
}